import ReactGA from 'react-ga4';

export const sendAnalytics = (title) => {
  ReactGA.send({ hitType: 'pageview', page: '/my-path', title: title });
};
